import { envs, placeholderImage } from "./constants";

// home page path
export const homePageRoutePath = process.env.NEXT_PUBLIC_HOME_PAGE_URL || "/";
export const categoryPageRoutePath = homePageRoutePath + "category/";
export const productPageRoutePath = homePageRoutePath + "product/";
export const brandPageRoutePath = homePageRoutePath + "brand/";
export const customPageRoutePath = homePageRoutePath + "pages/";
export const homepageRoutePathV2 = process.env.NEXT_PUBLIC_HOME_PAGE_URL_V2 || "/";

// member page path
export const memberPageRoutePath = homePageRoutePath + "user/";
export const memberSubRoutePaths = {
  dashboard: memberPageRoutePath,
  orderList: memberPageRoutePath + "orders",
  orderItemDetails: memberPageRoutePath + "order/",
  purchaseHistory: memberPageRoutePath + "history",
  refundRequest: memberPageRoutePath + "requests",
  digitalDownl: memberPageRoutePath + "download",
  profile: memberPageRoutePath + "profile",
  shippingAddress: memberPageRoutePath + "shipping",
  cart: memberPageRoutePath + "cart",
  wishlist: memberPageRoutePath + "wishlist",
};

/**
 * get page route path
 * @param type - page type
 * @param slug - path slug
 * @returns full route path
 * @author Azher Uddin <https://github.com/AzherUddin617>
 * @date 2022-09-03 23:29:25
 */
export const getPageRoute = (type: PageTypes, slug?: string) => {
  const s = slug || "";

  switch (type) {
    case "category":
      return "/category/" + s;
    case "page":
      return "/" + s;
    case "campaign":
      return "/campaign/" + s;
    case "custom":
      return s;
    case "brand":
      return "/brand/" + s;
    default:
      return "/"; // fallback to home when type is unknown
  }
};

/**
 * get S3 bucket image url
 * @param slug - image endpoint
 * @param type - s3 bucket type
 * @returns full image path
 * @author Azher Uddin <https://github.com/AzherUddin617>
 * @date 2022-09-03 23:31:47
 */
export const getS3ImageUrl = (slug: string, type: S3BucketTypes = "BASE") => {
  if (!slug || slug?.trim() === "") return placeholderImage;

  switch (type) {
    case "BASE":
      return envs.cdnLink + slug;
    case "MEDIA":
      return envs.cdnLink + slug;
  }
};
